import React from "react";
import { Link } from "react-router-dom";

import { ReactComponent as FaqIcon } from "../../../../assets/images/Help/Navigation/icon_faq.svg";
import { ReactComponent as EnvironmentIcon } from "../../../../assets/images/Help/Navigation/icon_environment.svg";
import { ReactComponent as ContactIcon } from "../../../../assets/images/Help/Navigation/icon_contact.svg";
import { manualPath } from "../../../../teacherStore";
import common from "../common.module.scss";

import styles from "./HelpNavigation.module.scss";

const navData = [
  {
    label: "よくあるご質問",
    Icon: FaqIcon,
    link: "#faq",
  },
  {
    label: "ご利用環境の確認",
    Icon: EnvironmentIcon,
    link: "#environment",
  },
  {
    label: "個別のお問い合わせ",
    Icon: ContactIcon,
    link: "#contact",
  },
];

const HelpNavigation = () => {
  return (
    <div className={styles.nav}>
      <div className={styles.list}>
        {navData.map((data, index) => {
          const { Icon, label } = data;
          const no = index + 1;

          return (
            <a key={no} className={styles.item} href={data.link}>
              <Icon />
              <div className={styles.caption}>
                <span>0{no}</span>
                <span>{label}</span>
              </div>
            </a>
          );
        })}
      </div>
      <p className={common.description}>
        各種マニュアルは
        <Link className={common.link} to={manualPath}>
          こちら
        </Link>
      </p>
    </div>
  );
};

export default HelpNavigation;
